import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getStoreNetwork } from "../../services/apiStoreNetwork";

// useGetStoreNetwork.js
export function useGetStoreNetwork(search, city_id, category) {
    const {
        isPending: isLoading,
        data: storeNetwork,
        error,
    } = useQuery({
        queryKey: ["store-network", i18next.language, search, city_id, category],
        queryFn: () => getStoreNetwork(search, city_id, category),
        // staleTime: 5 * 60 * 1000,     // 5 دقائق من الوقت "الطازج"
        // cacheTime: 10 * 60 * 1000,     // إبقاء الكاش 10 دقائق حتى بعد أن يصبح قديماً
        // refetchOnWindowFocus: false,   // لا تعيد الجلب عند رجوع الـ tab للتركيز
        // refetchOnMount: false,         // لا تعيد الجلب عند إعادة التركيب إذا لا يزال الكاش صالحاً
        // retry: false
    });

    return { isLoading, error, storeNetwork };
}